import React from 'react';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {FaSchool,FaUniversity} from 'react-icons/fa'

const Education = ()=>{
    
    return (
        <div
      name="education"
      className="w-full   bg-gradient-to-b from-gray-800 to-black text-white "
    >
      <div className="w-[90%] mx-auto flex flex-col items-center justify-between   md:flex-row py-24 pr-16">
        <div className="flex flex-col justify-center p-2 ">
          <h2 className="text-4xl sm:text-7xl font-bold text-white">
            Education
          </h2>
          <div style={{marginTop:'80px',width:'80vw',marginLeft:'auto',marginRight:'auto'}}>
          <VerticalTimeline>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'transparent', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date="2022 - present"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<FaUniversity />}
  >
    <h3 className="vertical-timeline-element-title">Virtual University </h3>
    <h4 className="vertical-timeline-element-subtitle">Lahore, Pakistan </h4>
    <p>
      I am doing my BSCS degree from Virtual University of Pakistan.
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'transparent', color: '#fff' }}
    date="2018 - 2019"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<FaUniversity />}
  >
    <h3 className="vertical-timeline-element-title">UET (University of Engineering and Technology)</h3>
    <h4 className="vertical-timeline-element-subtitle">Lahore , Pakistan</h4>
    <p>
      I have done my website development course from UET under PSDF.
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'transparent', color: '#fff' }}
    date="2016 - 2018"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<FaUniversity />}
  >
    <h3 className="vertical-timeline-element-title">Student </h3>
    <h4 className="vertical-timeline-element-subtitle">Lahore, Pakistan </h4>
    <p>
      I have done my FSC(Pre Engineering) from Government Shalimar College Lahore.
    </p>
  </VerticalTimelineElement>
 
  
  

  
</VerticalTimeline>
</div>
    </div>
    </div>
    </div>
    )
}

export default Education;